import React from 'react'
function DownArrow() {
   return (
      <svg
         width="18"
         height="11"
         viewBox="0 0 18 11"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            d="M16.9415 2.06982C17.3234 1.63305 17.2788 0.969781 16.8423 0.587942C16.4055 0.206497 15.7422 0.25109 15.3604 0.687561L8.80123 8.18416L2.24165 0.687167C1.85981 0.250302 1.19654 0.206103 0.760168 0.587548C0.323301 0.969386 0.278711 1.63266 0.660549 2.06952L8.01067 10.4694C8.10926 10.5821 8.2308 10.6724 8.36716 10.7343C8.50352 10.7962 8.65153 10.8282 8.80128 10.8282C8.95102 10.8282 9.09903 10.7962 9.23539 10.7343C9.37175 10.6724 9.49329 10.5821 9.59188 10.4694L16.9415 2.06982Z"
            fill="#1F473E"
         />
      </svg>
   )
}
export default DownArrow
